<bic-button [bicDropdownTrigger]="filterDropdown" buttonType="white" class="whitespace-nowrap"
            [tooltip]="'Filter' + (getFilterCount() ? ' (' + getFilterCount() + ')' : '')" tooltipDirection="bottom">
  <span [class]="labelClass">
    Filter
    <span class="inline-block w-6 text-center">({{ getFilterCount() }})</span>
  </span>
  <fa-icon [icon]="faFilter" iconLeft></fa-icon>
</bic-button>
<bic-dropdown #filterDropdown (close)="onDropdownClosed()">
  <div class="w-[320px]">
    <div class="flex flex-row items-center justify-between p-3 ">
      <span class="text-sm font-medium text-gray">Filter</span>
      <span (click)="clearAll()"
            class="text-sm font-medium text-gray-500 cursor-pointer hover:text-green-600 transition-colors">Aufheben</span>
    </div>
    @for (col of filtersConfig; track col.key) {
      <div class="border-b border-gray-100 last:border-b-0">
        <div (click)="toggleColumnAccordion(col.key)"
             class="flex flex-row items-center justify-between p-3 hover:bg-gray-50 cursor-pointer">
          <span [ngClass]="{'text-gray-500': expandedAccordionColumn!=col.key}"
                class="text-sm font-medium">{{ col.displayName }}{{ getSelectedCountLabel(col.key) }}</span>
          <fa-icon [icon]="faChevronDown"
                   [ngClass]="{'rotate-180': expandedAccordionColumn === col.key}"
                   class="text-xs transition-transform duration-200"></fa-icon>
        </div>
        @if (expandedAccordionColumn === col.key) {
          <div class="bg-white border-t border-gray-100">
            @for (value of getOptions(col); track value) {
              <div (click)="toggleFilterValue(col, value); $event.stopPropagation()"
                   class="px-3 py-2 text-sm font-medium text-gray cursor-pointer hover:bg-gray-50 transition-colors bg-white">
                <div class="flex flex-row items-center gap-3">
                  <input (change)="toggleFilterValue(col, value)"
                         (click)="$event.stopPropagation()"
                         [checked]="isSelected(col, value)"
                         class="w-4 h-4 bg-gray-50 border rounded border-gray-300 text-green-600 checked:bg-green focus:ring-[none] cursor-pointer"
                         type="checkbox">
                  <span [tooltip]="formatOption(col, value)"
                        class="flex-1 min-w-0 truncate text-gray-500 font-medium"
                        tooltipDirection="top">
                    {{ formatOption(col, value) }}
                  </span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</bic-dropdown>
